interface BreadCrumbsProps {
    title: string
    iconPath?: string
}

// "/img/icon-role.png"
export function TitleInDetailPage({title, iconPath}: BreadCrumbsProps) {
    return (
        <div className="sub-title">
            <div className="sub-text inline-box">
                <div>
                    {iconPath && (
                        <img src={iconPath} alt="role name 아이콘" style={{height: 72, width: 72}}/>
                    )}
                </div>
                <div className="mt20 ml20 is-size-5 has-text-weight-bold">{title}</div>
                <div className="mt20 ml20">
                    <button className="button is-size-7">
                        <span className="icon is-small  has-text-purple2">
                            <i className="fas fa-pen"></i>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    )
}